import React from 'react';
import { AIChatMessage } from '@/services/api';
import { ChatPreset } from './types';

interface ChatInputBarProps {
  messages: AIChatMessage[];
  presets: ChatPreset[];
  input: string;
  loading: boolean;
  inputRef: React.RefObject<HTMLInputElement | null>;
  onPresetClick: (preset: ChatPreset) => void;
  onClear: () => void;
  onInputChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  maxMessageLength?: number;
}

const ChatInputBar: React.FC<ChatInputBarProps> = ({
  messages,
  presets,
  input,
  loading,
  inputRef,
  onPresetClick,
  onClear,
  onInputChange,
  onSubmit,
  maxMessageLength,
}) => {
  return (
    <div className="flex-shrink-0 border-t border-gray-200 dark:border-gray-700 px-4 py-3 bg-white dark:bg-gray-900">
      {/* Follow-up presets */}
      {messages.length > 0 && (
        <div className="mb-2 flex items-center justify-between">
          <div className="flex flex-wrap gap-1">
            {presets.map(preset => (
              <button
                key={preset.id}
                onClick={() => onPresetClick(preset)}
                disabled={loading}
                className="px-2 py-0.5 text-xs text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded transition-colors disabled:opacity-50"
              >
                {preset.label}
              </button>
            ))}
          </div>
          <button
            onClick={onClear}
            className="text-xs text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors ml-2 flex-shrink-0"
          >
            Clear
          </button>
        </div>
      )}

      <form onSubmit={onSubmit} className="flex gap-2">
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={e => onInputChange(e.target.value)}
          placeholder={messages.length === 0 ? 'Ask a question or pick a preset...' : 'Ask a follow-up question...'}
          disabled={loading}
          maxLength={maxMessageLength}
          className="flex-1 px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:opacity-50"
        />
        <button
          type="submit"
          disabled={loading || !input.trim()}
          className="px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Send
        </button>
      </form>
    </div>
  );
};

export default ChatInputBar;
